<template>
  <div class="container-fluid mt-4">
    <b-row class="border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Personel Ekle</span>
      </b-col>
      <b-col cols="auto" class="text-right mb-3">
        <b-btn class="mr-3" type="button" variant="danger" to="/Staff" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Personeller</span>
        </b-btn>
      </b-col>
    </b-row>
    <form @submit.prevent="AddPerson">
      <table class="m-3 hidden-sm-down display-ib align-top">
        <tr>
          <td>{{ Enums.Role }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-select v-model="Person.RoleID" :options="RolesGUI"></b-form-select>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <td>{{ Enums.Name }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input type="text" v-model="Person.Name" @keypress.enter.prevent="AddPerson"></b-form-input>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <td>{{ Enums.Phone }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input type="text" v-model="Person.Phone" @keypress.enter.prevent="AddPerson"></b-form-input>
            </b-form-group>
          </td>
        </tr>
      </table>

      <table class="m-3 hidden-sm-down display-ib align-top">
        <tr>
          <td>{{ Enums.Username }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input
                type="text"
                v-model="Person.Username"
                @keypress.enter.prevent="AddPerson"
              ></b-form-input>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <td>{{ Enums.Password }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input
                type="password"
                v-model="Person.Password"
                @keypress.enter.prevent="AddPerson"
              ></b-form-input>
            </b-form-group>
          </td>
        </tr>
      </table>

      <b-form-group class="formgroup hidden-md-up" :label="Enums.Role">
        <b-form-select v-model="Person.RoleID" :options="RolesGUI"></b-form-select>
      </b-form-group>

      <b-form-group
        class="formgroup hidden-md-up"
        :label="Enums[index]"
        v-for="(property, index) in PersonGUI"
        :key="index"
      >
        <b-form-input
          :type="index === 'Password' ? 'password' : 'text'"
          v-model="Person[index]"
          @keypress.enter.prevent="AddPerson"
        ></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        Role: "Rolü",
        Username: "Kullanıcı Adı Belirle",
        Password: "Şifre Belirle",
        Name: "Adı Soyadı",
        Phone: "Cep Telefonu"
      },
      Person: {
        Name: "",
        Phone: "",
        RoleID: 2,
        Username: "",
        Password: ""
      }
    };
  },
  computed: {
    ...mapGetters(["GetStoreData"]),
    ...mapState(["ButtonSize"]),
    PersonGUI() {
      return Object.filterKey(this.Person, x => ["RoleID"].indexOf(x) === -1);
    },
    RolesGUI() {
      let _Roles = [];

      for (let i in this.GetStoreData.Roles) {
        const _Role = this.GetStoreData.Roles[i];

        _Roles.push({
          value: _Role.ID,
          text: _Role.Name
        });
      }

      return _Roles;
    }
  },
  methods: {
    async AddPerson() {
      await this.$store.dispatch("ClearToastMessages");
      await this.$store.dispatch("RemoveAlerts");

      if (String(this.Person.Password).length < 4) {
        await this.$store.dispatch("AddToastMessage", {
          Body: "Şifre 4 haneden kısa olamaz!"
        });

        return false;
      }

      await this.$store.dispatch("AddLoading", "AddPerson");

      await Services.Nozich.Send(
        "AddPerson",
        {
          Person: this.Person
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddPerson");

          if (Data.Status === "Success") {
            await this.$router.push("/Staff");
          } else if (Data.Message) {
            await this.$store.dispatch("GiveError", Data.Message);
          }
        }
      );
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
